import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({

    root: {
        height: '100%',
        backgroundColor: '#F7FAFF',
      },
      
      toolbar: {
          display: 'flex',
          gap: theme.spacing(1),
          borderBottomLeftRadius: '30px',
          borderBottomRightRadius: '30px',
          backgroundColor: theme.palette.primary.main,
        },
  
        mainContainer: {
          display: 'flex',
          gap: theme.spacing(2),
          padding: theme.spacing(3),
          paddingBottom: '0',
        },
      
        mixerDiv: {
          display: 'flex',
          width: '50%',
          justifyContent: 'right',
        },
      
        mixerButton: {
          borderRadius: '15px',
          right:theme.spacing(2),
        },
  
        mixerIcon: {
          width:'40px',
          height: '40px',
          borderRadius: '10px',
          padding: theme.spacing(0.3),
          backgroundColor: theme.palette.primary.main,
          fill: theme.palette.secondary.main,
        },
      
        leftTitle: {
         width: '50%',
         color: '#777777',
        },
  
        settingsCard: {
          margin: theme.spacing(3),
          padding: theme.spacing(0),
          borderRadius: '15px',
        },
      
        settingsCardIcon: {
          fill: theme.palette.primary.main,
          width: '40px',
          height: '40px',
          padding: '0',
        },
      
        settingsCardHeader: {
          padding: theme.spacing(1),
          fontSize: '10pt'
        },

        //Notifications styles
   
        notificationTab: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            '& .MuiTabs-indicator': {
            display:'none',
            },
        },

        notificationTabButtons: {
            backgroundColor: '#fff',
            borderRadius: '30px',
            boxShadow: ' 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.10)',
            padding: theme.spacing(0.5),
            '& button': {
            paddingLeft: theme.spacing(6),
            paddingRight: theme.spacing(6),
            },
            '& .Mui-selected': {
            backgroundColor:'#5D7ECC',
            borderRadius: '30px',
            color:'#fff',
            border: '0 px solid'
            },
        },

        notificationsTabPanel: {

        },

        notificationsBadge: {
            padding: theme.spacing(3),
            display:'inline-block',
        },

        notificationStack: {
            width: '100%',
        },

}));